export default __webpack_public_path__ + "static/media/recommendations-student-profile-preview.873ed682.png";